export default {
  setProperty(state, { payload, property }) {
    state[property] = payload;
  },
};
